
import Vue from 'vue'
import Vuex from 'vuex'
 
//1.安装插件
Vue.use(Vuex)
 
//2.创建对象
const store = new Vuex.Store({
  state:{
    txl_school_id:localStorage.getItem("txl_school_id")?+localStorage.getItem("txl_school_id"):null,
    color:'#FF9500 ',
    comView:{}
  },
  mutations:{
    setComView(state, params) {
      state.comView = params
    },
  },
  actions:{
    setComView: ({ commit }, params) => commit('setComView', params),
  },
  getters:{
    comView: state => state.comView,
  },
  modules:{
    
  }
})
//3.导出使用
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js